import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';

import SVG from 'components/SVG';

import arrowSVG from './img/arrow-right.svg';

import './TableRow.scss';

const TableRow = ({ item, locale }) => {
  const b = block('table-row-cashback-history-desktop');

  return (
    <div className={b()}>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.date}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.id}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.username}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.amount}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.cashbackPercent}</span>
      </div>
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TableRow;
